export enum DocumentType {
  Unknown = 'Unknown',
  Bonus = 'Bonus',
  BonusPerformance = 'BonusPerformance',
  BonusPool = 'BonusPool',
  BonusJp = 'BonusJp',
  ProvisionItaly = 'ProvisionItaly',
  InvoiceMpm = 'InvoiceMpm'
}
